import * as React from "react";
import {Container, Navbar, NavbarBrand} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {enableLanguages, mapI18nStateToProps, selectLanguageAction} from "App/translations";
import {connect} from "react-redux";
import {selectedLang} from "App/helper";
import {Language} from "App/constants";

var img = require('Assets/images/logo.svg');

const mapDispatchToProps = (dispatch: any) => ({
    changeLanguage: (lang:Language) => {
        dispatch(selectLanguageAction(lang));
    }
});

class _Header extends React.Component<any, any> {

    langComponent(language:Language, current:Language) {
        return (<div key={language} className={language == current?"CUR":"NO SPC"}>
            <span className="linked-language" onClick={() => {this.props.changeLanguage(language)}}>{language}</span>
        </div>);
    }

    render() {
        const { t, i18n, currency } = this.props;
        const language: Language = selectedLang(i18n);
        return (
            <Container className="p-0">
                <Navbar className="px-0">
                    <NavbarBrand href="https://www.avesco.ch" className="pl-3 pl-sm-0 h-100"><img src={img} alt="Avesco logo" height="56"></img></NavbarBrand>
                    <div className="languagemenu d-flex h-100">
                        <div className={'px-3'}>
                            {t('products.configuration.actualversion', {version: process.env.REACT_APP_VERSION})}
                        </div>|
                        <div className={'px-3'}>
                            {t('products.configuration.actualcurrency', {currency: currency})}
                        </div>|
                        <div className={'pl-3'}>
                            {
                                enableLanguages().map(value => this.langComponent(value, language))
                            }
                        </div>
                    </div>
                </Navbar>
            </Container>
        );
    }
}
export const Header = connect (mapI18nStateToProps, mapDispatchToProps)(withTranslation('common')(_Header));



// WEBPACK FOOTER //
// ./src/fragments/Header.tsx